const copyToClipboard = function (text) {
    if (!navigator.clipboard) {
        fallbackCopyTextToClipboard(text);
        return;
    }
    navigator.clipboard.writeText(text).then(function () { }, function () { });
}

const fallbackCopyTextToClipboard = function (text) {
    var textArea = document.createElement('textarea');
    textArea.value = text;

    // Avoid scrolling to bottom
    textArea.style.top = '0';
    textArea.style.left = '0';
    textArea.style.position = 'fixed';

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    // try {
    //     // var successful = document.execCommand('copy');
    //     // var msg = successful ? 'successful' : 'unsuccessful';
    // } catch (err) { }

    document.body.removeChild(textArea);
}
export default copyToClipboard;


// WEBPACK FOOTER //
// ./scripts/util/copyToClipboard.js